import React from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export function FavoriteButton({ editorId, className = "", size = 18, onToggle }) {
    const { user, toggleFavorite } = useAuth();
    const isFav = user && Array.isArray(user.favorites) && user.favorites.includes(editorId);

    const handle = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) { toast.error("Accedi per salvare un editor"); return; }
        if (user.role !== "writer") { toast.error("Solo gli scrittori possono salvare editor"); return; }
        await toggleFavorite(editorId);
        toast.success(isFav ? "Rimosso dai preferiti" : "Salvato nei preferiti");
        if (onToggle) onToggle();
    };

    return (
        <button onClick={handle} data-testid={`fav-btn-${editorId}`} aria-label="Salva editor"
            className={`p-2 rounded-full bg-background/90 backdrop-blur shadow-sm hover:bg-background transition-colors ${className}`}>
            <Heart size={size} className={isFav ? "fill-primary text-primary" : "text-foreground"} strokeWidth={1.8} />
        </button>
    );
}
